import { useState } from "react";
import { IsiCreate } from "./IsiCreate";
import { useLoaderData, useParams } from "react-router-dom";

export function IsiNew(props) {
  const isi = useLoaderData();

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);


  // Set default valor for today date
  const todayDate = new Date().toISOString().replace(/T.*/,'').split('-').join('-');

  // Set number of sesion based on number of items published
  let isiLength = isi.length;
  let currentSesion = isiLength + 1;

  const [isiResp, setIsiResp] = useState(props.especialistaFullName);
  const [isiFecha, setIsiFecha] = useState(todayDate);
  const [isiPreg001a, setIsiPreg001a] = useState("");
  const [isiPreg001b, setIsiPreg001b] = useState("");
  const [isiPreg001c, setIsiPreg001c] = useState("");
  const [isiPreg002, setIsiPreg002] = useState("");
  const [isiPreg003, setIsiPreg003] = useState("");
  const [isiPreg004, setIsiPreg004] = useState("");
  const [isiPreg005, setIsiPreg005] = useState("");
  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();

  const submitIsi = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      isiResp,
      isiFecha,
      isiPreg001a,
      isiPreg001b,
      isiPreg001c,
      isiPreg002,
      isiPreg003,
      isiPreg004,
      isiPreg005,
      tratamientoId,
      pacienteId
    );
    try {
      await IsiCreate(
        isiResp,
        isiFecha,
        isiPreg001a,
        isiPreg001b,
        isiPreg001c,
        isiPreg002,
        isiPreg003,
        isiPreg004,
        isiPreg005,
        tratamientoId,
        pacienteId
      ).then(
        (val) => {
          window.location.replace(
            `../isi/${val.id}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        <form id='formNewElement' onSubmit={submitIsi}>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='isiResp'>Responsable</label>
              <div className='control'>
                <input
                  className='input'
                  id='isiResp'
                  required
                  type='text'
                  value={isiResp}
                  onChange={(e) => setIsiResp(e.target.value)}
                />
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiFecha'>Fecha visita</label>
              <div className='control'>
                <input
                  className='input'
                  id='isiFecha'
                  required
                  type='date'
                  value={isiFecha}
                  onChange={(e) => setIsiFecha(e.target.value)}
                />
              </div>
            </div>
          </div>
          <h3>Cuestionario ISI</h3>
          <div className='grid--2col'>
            <div className='field'>
              <label htmlFor='isiPreg001a'>
                1 a. En las últimas dos semanas, indique el nivel de GRAVEDAD en
                la dificultad para quedarse dormido/a
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg001a'
                    required
                    name='isiPreg001a'
                    defaultValue=''
                    onChange={(e) => setIsiPreg001a(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Leve</option>
                    <option value='2'>Moderado</option>
                    <option value='3'>Grave</option>
                    <option value='4'>Muy grave</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg001b'>
                1 b. En las últimas dos semanas, indique el nivel de GRAVEDAD en
                la dificultad para permanecer dormido/a
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg001b'
                    required
                    name='isiPreg001b'
                    defaultValue=''
                    onChange={(e) => setIsiPreg001b(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Leve</option>
                    <option value='2'>Moderado</option>
                    <option value='3'>Grave</option>
                    <option value='4'>Muy grave</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg001c'>
                1 c. En las últimas dos semanas, indique el nivel de GRAVEDAD en
                la dificultad para despertarse demasiado temprano
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg001c'
                    required
                    name='isiPreg001c'
                    defaultValue=''
                    onChange={(e) => setIsiPreg001c(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Leve</option>
                    <option value='2'>Moderado</option>
                    <option value='3'>Grave</option>
                    <option value='4'>Muy grave</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg002'>
                2. ¿Cuán SATISFECHO / INSATISFECHO está con su patrón de sueño
                actual?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg002'
                    required
                    name='isiPreg002'
                    defaultValue=''
                    onChange={(e) => setIsiPreg002(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Muy satisfecho</option>
                    <option value='1'>Algo satisfecho</option>
                    <option value='2'>Satisfecho</option>
                    <option value='3'>Algo insatisfecho</option>
                    <option value='4'>Muy insatisfecho</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg003'>
                3. ¿En qué medida considera que su problema de sueño INTERFIERE
                con su funcionamiento diario (por ejemplo, cansancio durante el
                día, capacidad para realizar las tareas cotidianas / trabajo,
                concentración, memoria, estado de ánimo, etc.)?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg003'
                    required
                    name='isiPreg003'
                    defaultValue=''
                    onChange={(e) => setIsiPreg003(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Un poco</option>
                    <option value='2'>Algo</option>
                    <option value='3'>Mucho</option>
                    <option value='4'>Muchísimo</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg004'>
                4. ¿En qué medida cree que los demás SE DAN CUENTA de su
                problema de sueño por lo que afecta a su calidad de vida?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg004'
                    required
                    name='isiPreg004'
                    defaultValue=''
                    onChange={(e) => setIsiPreg004(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Casi nada</option>
                    <option value='2'>Algo</option>
                    <option value='3'>Mucho</option>
                    <option value='4'>Muchísimo</option>
                  </select>
                </div>
              </div>
            </div>
            <div className='field'>
              <label htmlFor='isiPreg005'>
                5. ¿Cuán PREOCUPADO / ANGUSTIADO está por su actual problema de
                sueño?
              </label>
              <div className='control'>
                <div className='select'>
                  <select
                    className='select'
                    id='isiPreg005'
                    required
                    name='isiPreg005'
                    defaultValue=''
                    onChange={(e) => setIsiPreg005(e.target.value)}
                  >
                    <option disabled value=''>-- Selecciona una opción --</option>
                    <option value='0'>Nada</option>
                    <option value='1'>Un poco</option>
                    <option value='2'>Algo</option>
                    <option value='3'>Mucho</option>
                    <option value='4'>Muchísimo</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div id='actions'>
        <button 
        className='button is-link' 
        form='formNewElement' 
        type='submit'
        disabled={isCreatingButton}
        >
          {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
        </button>
      </div>
    </>
  );
}
